const atom = <T>(_: string, factory: () => T) => factory();

const molecule = <T>(_: string, factory: () => T) => factory();

export { atom, molecule };
